<template>
    <div>COLLECTOR CORRECTIONS REPORT PAGE</div>
</template>